/**
 * Esgotados por último — coleção e busca.
 *
 * O Liquid só enxerga a página atual do `{% paginate %}`, então as seções já renderizam
 * os disponíveis antes dos esgotados e o CSS usa `order` pra empurrar os esgotados pro fim
 * da grade. Isso resolve dentro do que está carregado, mas com infinite scroll os esgotados
 * do lote 1 apareciam antes do lote 2 existir.
 *
 * Aqui a grade só libera os esgotados (`data-all-loaded="true"`) quando TODAS as páginas
 * do resultado já estão no DOM. Enquanto isso o CSS os mantém escondidos.
 *
 * Não reordenamos o DOM de propósito: `paginated-list.js` usa a ordem real dos cards
 * (o `data-page` do último card) pra calcular qual página buscar em seguida.
 */
(() => {
  const GRID_SELECTOR = '.product-grid[data-sold-out-last="true"]';
  const CARD_SELECTOR = ':scope > [ref="cards[]"]';
  const SOLD_OUT_CLASS = 'product-grid__item--sold-out';

  /** @param {HTMLElement} grid */
  const sync = (grid) => {
    const cards = grid.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    const lastPage = Number(grid.dataset.lastPage) || 1;
    const pages = new Set();
    let inStock = 0;

    for (const card of cards) {
      pages.add(Number(card.dataset.page) || 1);
      if (!card.classList.contains(SOLD_OUT_CLASS)) inStock += 1;
    }

    // `pages.size >= lastPage` cobre quem entrou direto por ?page=4: o tema carrega pra
    // cima e pra baixo, então só fecha quando as páginas 1..N estiverem todas presentes.
    // `inStock === 0` evita página em branco quando o filtro só devolve esgotados.
    const complete = pages.size >= lastPage || inStock === 0;
    const value = complete ? 'true' : 'false';

    if (grid.dataset.allLoaded !== value) grid.dataset.allLoaded = value;
  };

  const syncAll = () => {
    for (const grid of document.querySelectorAll(GRID_SELECTOR)) sync(grid);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncAll();
    });
  };

  // Observa só `childList` pra que escrever o `data-all-loaded` não realimente o observer.
  // O escopo é o body porque filtros/ordenação re-renderizam a seção inteira.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

  syncAll();
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('pageshow', syncAll);
})();
